// Retrieve focusable elements from a container
function getFocusableElements(container) {
  return Array.from(
    container.querySelectorAll(
      "summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe"
    )
  );
}

// Check if mobile
if (/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)) {
  window.isMobile = true;
} else {
  window.isMobile = false;
}

// Detail/summary elements a11y
document.querySelectorAll('[id^="Details-"] summary').forEach((summary) => {
  summary.setAttribute('role', 'button');
  summary.setAttribute('aria-expanded', summary.parentNode.hasAttribute('open'));

  if (summary.nextElementSibling.getAttribute('id')) {
    summary.setAttribute('aria-controls', summary.nextElementSibling.id);
  }

  summary.addEventListener('click', (event) => {
    event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
  });

  if (summary.closest('header-drawer')) return;
  summary.parentElement.addEventListener('keyup', onKeyUpEscape);
});

// Trap focus helper
const trapFocusHandlers = {};

function trapFocus(container, elementToFocus = container) {
  var elements = getFocusableElements(container);
  var first = elements[0];
  var last = elements[elements.length - 1];

  removeTrapFocus();

  trapFocusHandlers.focusin = (event) => {
    if (event.target !== container && event.target !== last && event.target !== first) return;

    document.addEventListener('keydown', trapFocusHandlers.keydown);
  };

  trapFocusHandlers.focusout = function () {
    document.removeEventListener('keydown', trapFocusHandlers.keydown);
  };

  trapFocusHandlers.keydown = function (event) {
    if (event.code.toUpperCase() !== 'TAB') return; // If not TAB key
    // On the last focusable element and tab forward, focus the first element.
    if (event.target === last && !event.shiftKey) {
      event.preventDefault();
      first.focus();
    }

    // On the first focusable element and tab backward, focus the last element.
    if ((event.target === container || event.target === first) && event.shiftKey) {
      event.preventDefault();
      last.focus();
    }
  };

  document.addEventListener('focusout', trapFocusHandlers.focusout);
  document.addEventListener('focusin', trapFocusHandlers.focusin);

  elementToFocus.focus();

  if (
    elementToFocus.tagName === 'INPUT' &&
    ['search', 'text', 'email', 'url'].includes(elementToFocus.type) &&
    elementToFocus.value
  ) {
    elementToFocus.setSelectionRange(0, elementToFocus.value.length);
  }
}

// Here run the querySelector to figure out if the browser supports :focus-visible or not and run code based on it.
try {
  document.querySelector(':focus-visible');
} catch (e) {
  focusVisiblePolyfill();
}

// Focus visible polyfill
function focusVisiblePolyfill() {
  const navKeys = [
    'ARROWUP',
    'ARROWDOWN',
    'ARROWLEFT',
    'ARROWRIGHT',
    'TAB',
    'ENTER',
    'SPACE',
    'ESCAPE',
    'HOME',
    'END',
    'PAGEUP',
    'PAGEDOWN',
  ];
  let currentFocusedElement = null;
  let mouseClick = null;

  window.addEventListener('keydown', (event) => {
    if (navKeys.includes(event.code.toUpperCase())) {
      mouseClick = false;
    }
  });

  window.addEventListener('mousedown', (event) => {
    mouseClick = true;
  });

  window.addEventListener(
    'focus',
    () => {
      if (currentFocusedElement) currentFocusedElement.classList.remove('focused');

      if (mouseClick) return;

      currentFocusedElement = document.activeElement;
      currentFocusedElement.classList.add('focused');
    },
    true
  );
}

// Pause all playing media helper
function pauseAllMedia() {
  document.querySelectorAll('.js-youtube').forEach((video) => {
    video.contentWindow.postMessage('{"event":"command","func":"' + 'pauseVideo' + '","args":""}', '*');
  });
  document.querySelectorAll('.js-vimeo').forEach((video) => {
    video.contentWindow.postMessage('{"method":"pause"}', '*');
  });
  document.querySelectorAll('video').forEach((video) => video.pause());
  document.querySelectorAll('product-model').forEach((model) => {
    if (model.modelViewerUI) model.modelViewerUI.pause();
  });
}

function removeTrapFocus(elementToFocus = null) {
  document.removeEventListener('focusin', trapFocusHandlers.focusin);
  document.removeEventListener('focusout', trapFocusHandlers.focusout);
  document.removeEventListener('keydown', trapFocusHandlers.keydown);

  if (elementToFocus) elementToFocus.focus();
}

// Escape key helper
function onKeyUpEscape(event) {
  if (event.code.toUpperCase() !== 'ESCAPE') return;

  const openDetailsElement = event.target.closest('details[open]');
  if (!openDetailsElement) return;

  const summaryElement = openDetailsElement.querySelector('summary');
  openDetailsElement.removeAttribute('open');
  summaryElement.setAttribute('aria-expanded', false);
  summaryElement.focus();
}

// Scroll bar width helpers
function getScrollBarWidth(initial = false) {
  if (document.documentElement.scrollHeight <= window.innerHeight) {
    return 0;
  }

  const scrollDiv = document.createElement('div');
  scrollDiv.className = 'scrollbar-measure';
  document.body.appendChild(scrollDiv);

  const scrollbarWidth = scrollDiv.offsetWidth - scrollDiv.clientWidth;

  document.body.removeChild(scrollDiv);
  if (initial) {
    document.documentElement.style.setProperty(
      '--scrollbar-gutter',
      `${document.documentElement.scrollHeight <= window.innerHeight ? 0 : scrollbarWidth}px`
    );
    return;
  }
  return scrollbarWidth;
}

getScrollBarWidth(true);

function addScrollbarPadding() {
  if (window.isMobile) return;
  document.body.style.paddingRight = `${getScrollBarWidth()}px`;
  document.body.classList.add('scrollbar-adjust');
}

function removeScrollbarPadding() {
  if (window.isMobile) return;
  document.body.style.paddingRight = '0px';
  document.body.classList.remove('scrollbar-adjust');
}

// Show overlay
function showFullOverlay(topElement) {
  const fullOverlay = document.querySelector('#OverlayFull');
  if (topElement) topElement.style.zIndex = 11;
  fullOverlay.classList.add('is-visible');
}

// Hide overlay
function hideFullOverlay(topElement) {
  const fullOverlay = document.querySelector('#OverlayFull');
  fullOverlay.classList.remove('is-visible');
  fullOverlay.addEventListener(
    'transitionend',
    () => {
      if (topElement) topElement.style.zIndex = null;
    },
    { once: true }
  );
}

// Debounce helper
function debounce(fn, wait) {
  let t;
  return (...args) => {
    clearTimeout(t);
    t = setTimeout(() => fn.apply(this, args), wait);
  };
}

// Throttle helper
function throttle(fn, delay) {
  let lastCall = 0;
  return function (...args) {
    const now = new Date().getTime();
    if (now - lastCall < delay) {
      return;
    }
    lastCall = now;
    return fn(...args);
  };
}

// Fetch config helper
function fetchConfig(type = 'json') {
  return {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Accept: `application/${type}`,
    },
  };
}

// Shopify JS
if (typeof window.Shopify == 'undefined') {
  window.Shopify = {};
}

if (Shopify.designMode) {
  document.documentElement.classList.add('shopify-design-mode');
}

Shopify.bind = function (fn, scope) {
  return function () {
    return fn.apply(scope, arguments);
  };
};

Shopify.setSelectorByValue = function (selector, value) {
  for (var i = 0, count = selector.options.length; i < count; i++) {
    var option = selector.options[i];
    if (value == option.value || value == option.innerHTML) {
      selector.selectedIndex = i;
      return i;
    }
  }
};

Shopify.addListener = function (target, eventName, callback) {
  target.addEventListener
    ? target.addEventListener(eventName, callback, false)
    : target.attachEvent('on' + eventName, callback);
};

Shopify.postLink = function (path, options) {
  options = options || {};
  var method = options['method'] || 'post';
  var params = options['parameters'] || {};

  var form = document.createElement('form');
  form.setAttribute('method', method);
  form.setAttribute('action', path);

  for (var key in params) {
    var hiddenField = document.createElement('input');
    hiddenField.setAttribute('type', 'hidden');
    hiddenField.setAttribute('name', key);
    hiddenField.setAttribute('value', params[key]);
    form.appendChild(hiddenField);
  }
  document.body.appendChild(form);
  form.submit();
  document.body.removeChild(form);
};

Shopify.CountryProvinceSelector = function (country_domid, province_domid, options) {
  this.countryEl = document.getElementById(country_domid);
  this.provinceEl = document.getElementById(province_domid);
  this.provinceContainer = document.getElementById(options['hideElement'] || province_domid);

  Shopify.addListener(this.countryEl, 'change', Shopify.bind(this.countryHandler, this));

  this.initCountry();
  this.initProvince();
};

Shopify.CountryProvinceSelector.prototype = {
  initCountry: function () {
    var value = this.countryEl.getAttribute('data-default');
    Shopify.setSelectorByValue(this.countryEl, value);
    this.countryHandler();
  },

  initProvince: function () {
    var value = this.provinceEl.getAttribute('data-default');
    if (value && this.provinceEl.options.length > 0) {
      Shopify.setSelectorByValue(this.provinceEl, value);
    }
  },

  countryHandler: function (e) {
    var opt = this.countryEl.options[this.countryEl.selectedIndex];
    var raw = opt.getAttribute('data-provinces');
    var provinces = JSON.parse(raw);

    this.clearOptions(this.provinceEl);
    if (provinces && provinces.length == 0) {
      this.provinceContainer.style.display = 'none';
    } else {
      for (var i = 0; i < provinces.length; i++) {
        var opt = document.createElement('option');
        opt.value = provinces[i][0];
        opt.innerHTML = provinces[i][1];
        this.provinceEl.appendChild(opt);
      }

      this.provinceContainer.style.display = '';
    }
  },

  clearOptions: function (selector) {
    while (selector.firstChild) {
      selector.removeChild(selector.firstChild);
    }
  },

  setOptions: function (selector, values) {
    for (var i = 0, count = values.length; i < values.length; i++) {
      var opt = document.createElement('option');
      opt.value = values[i];
      opt.innerHTML = values[i];
      selector.appendChild(opt);
    }
  },
};

async function storefrontRequest(queryString) {
  try {
    const queryConstructor = () => `query ${queryString}`;
    const response = await fetch(window.graphqlUrl, {
      async: true,
      crossDomain: true,
      method: 'POST',
      headers: {
        'X-Shopify-Storefront-Access-Token': window.storefrontAccessToken,
        'Content-Type': 'application/graphql',
      },
      body: queryConstructor(),
    });
    const jsonData = await response.json();
    console.log(jsonData);
    return jsonData.data;
  } catch (error) {
    console.error('Error fetching Shopify data:', error);
    throw error;
  }
}

class QuantityInput extends HTMLElement {
  constructor() {
    super();
    this.input = this.querySelector('input');
    this.changeEvent = new Event('change', { bubbles: true });

    this.input.addEventListener('change', this.onInputChange.bind(this));
    this.querySelectorAll('button').forEach((button) =>
      button.addEventListener('click', this.onButtonClick.bind(this))
    );
  }

  quantityUpdateUnsubscriber = undefined;

  connectedCallback() {
    this.validateQtyRules();
    this.quantityUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.quantityUpdate, this.validateQtyRules.bind(this));
  }

  disconnectedCallback() {
    if (this.quantityUpdateUnsubscriber) {
      this.quantityUpdateUnsubscriber();
    }
  }

  onInputChange(event) {
    this.validateQtyRules();
  }

  onButtonClick(event) {
    event.preventDefault();
    const previousValue = this.input.value;

    event.target.name === 'plus' ? this.input.stepUp() : this.input.stepDown();
    if (previousValue !== this.input.value) this.input.dispatchEvent(this.changeEvent);
  }

  validateQtyRules() {
    const value = parseInt(this.input.value);
    if (this.input.min) {
      const min = parseInt(this.input.min);
      const buttonMinus = this.querySelector(".quantity__button[name='minus']");
      buttonMinus.classList.toggle('disabled', value <= min);
    }
    if (this.input.max) {
      const max = parseInt(this.input.max);
      const buttonPlus = this.querySelector(".quantity__button[name='plus']");
      buttonPlus.classList.toggle('disabled', value >= max);
    }
  }
}

customElements.define('quantity-input', QuantityInput);

class MenuDrawer extends HTMLElement {
  constructor() {
    super();

    this.mainDetailsToggle = this.querySelector('details');

    this.addEventListener('keyup', this.onKeyUp.bind(this));
    this.addEventListener('focusout', this.onFocusOut.bind(this));
    this.bindEvents();
  }

  bindEvents() {
    this.querySelectorAll('summary').forEach((summary) =>
      summary.addEventListener('click', this.onSummaryClick.bind(this))
    );
    this.querySelectorAll('button:not([disabled])').forEach((button) => button.addEventListener('click', this.onCloseButtonClick.bind(this)));
  }

  // Clears scroll on drawer scroll parents so a newly opened submenu starts at the top.
  resetDrawerScrollForSubmenu(detailsElement) {
    const inner = this.querySelector('.menu-drawer__inner');
    const navContainer = this.querySelector('.menu-drawer__navigation-container');
    if (inner) inner.scrollTop = 0;
    if (navContainer) navContainer.scrollTop = 0;
    const innerSubmenu = detailsElement.querySelector('.menu-drawer__inner-submenu');
    if (innerSubmenu) innerSubmenu.scrollTop = 0;
  }

  onKeyUp(event) {
    if (event.code.toUpperCase() !== 'ESCAPE') return;

    const openDetailsElement = event.target.closest('details[open]');
    if (!openDetailsElement) return;

    openDetailsElement === this.mainDetailsToggle
      ? this.closeMenuDrawer(event, this.mainDetailsToggle.querySelector('summary'))
      : this.closeSubmenu(openDetailsElement);
  }

  onSummaryClick(event) {
    const summaryElement = event.currentTarget;
    const detailsElement = summaryElement.parentNode;
    const parentMenuElement = detailsElement.closest('.has-submenu');
    const isOpen = detailsElement.hasAttribute('open');
    const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

    function addTrapFocus() {
      trapFocus(summaryElement.nextElementSibling, detailsElement.querySelector('button'));
      summaryElement.nextElementSibling.removeEventListener('transitionend', addTrapFocus);
    }

    if (detailsElement === this.mainDetailsToggle) {
      if (isOpen) event.preventDefault();
      isOpen ? this.closeMenuDrawer(event, summaryElement) : this.openMenuDrawer(summaryElement);

      if (window.matchMedia('(max-width: 999px)')) {
        document.documentElement.style.setProperty('--viewport-height', `${window.innerHeight}px`);
      }
    } else {
      setTimeout(() => {
        if (detailsElement.hasAttribute('open')) {
          this.resetDrawerScrollForSubmenu(detailsElement);
        }
        detailsElement.classList.add('menu-opening');
        summaryElement.setAttribute('aria-expanded', true);
        parentMenuElement && parentMenuElement.classList.add('submenu-open');
        !reducedMotion || reducedMotion.matches
          ? addTrapFocus()
          : summaryElement.nextElementSibling.addEventListener('transitionend', addTrapFocus);
      }, 100);
    }
  }

  openMenuDrawer(summaryElement) {
    setTimeout(() => {
      this.mainDetailsToggle.classList.add('menu-opening');
    });
    summaryElement.setAttribute('aria-expanded', true);
    trapFocus(this.mainDetailsToggle, summaryElement);
  }

  closeMenuDrawer(event, elementToFocus = false) {
    if (event === undefined) return;

    this.mainDetailsToggle.classList.remove('menu-opening');
    // Close any open submenus on main menu close
    this.closeAnimation(this.mainDetailsToggle, () => {
      const openNested = [...this.mainDetailsToggle.querySelectorAll('details[open]')].reverse();
      openNested.forEach((details) => this.closeSubmenu(details));
    });
    removeTrapFocus(elementToFocus);

    if (event instanceof KeyboardEvent) elementToFocus?.setAttribute('aria-expanded', false);
  }

  onFocusOut() {
    setTimeout(() => {
      if (this.mainDetailsToggle.hasAttribute('open') && !this.mainDetailsToggle.contains(document.activeElement))
        this.closeMenuDrawer();
    });
  }

  onCloseButtonClick(event) {
    const detailsElement = event.currentTarget.closest('details');
    this.closeSubmenu(detailsElement);
  }

  closeSubmenu(detailsElement) {
    const parentMenuElement = detailsElement.closest('.submenu-open');
    parentMenuElement && parentMenuElement.classList.remove('submenu-open');
    detailsElement.classList.remove('menu-opening');
    detailsElement.querySelector('summary').setAttribute('aria-expanded', false);
    removeTrapFocus(detailsElement.querySelector('summary'));
    this.closeAnimation(detailsElement);
  }

  closeAnimation(detailsElement, onComplete) {
    let animationStart;

    const handleAnimation = (time) => {
      if (animationStart === undefined) {
        animationStart = time;
      }

      const elapsedTime = time - animationStart;

      if (elapsedTime < 400) {
        window.requestAnimationFrame(handleAnimation);
      } else {
        detailsElement.removeAttribute('open');
        if (detailsElement.closest('details[open]')) {
          trapFocus(detailsElement.closest('details[open]'), detailsElement.querySelector('summary'));
        }
        onComplete?.();
      }
    };

    window.requestAnimationFrame(handleAnimation);
  }
}

customElements.define('menu-drawer', MenuDrawer);

class HeaderDrawer extends MenuDrawer {
  constructor() {
    super();
  }

  openMenuDrawer(summaryElement) {
    this.header = this.header || document.querySelector('.section-header');
    this.borderOffset =
      this.borderOffset || this.closest('.header-wrapper').classList.contains('header-wrapper--border-bottom') ? 1 : 0;
    document.documentElement.style.setProperty(
      '--header-bottom-position',
      `${parseInt(this.header.getBoundingClientRect().bottom - this.borderOffset)}px`
    );
    this.header.classList.add('menu-open');

    setTimeout(() => {
      this.mainDetailsToggle.classList.add('menu-opening');
    });

    summaryElement.setAttribute('aria-expanded', true);
    window.addEventListener('resize', this.onResize);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add('overflow-hidden');
  }

  closeMenuDrawer(event, elementToFocus) {
    if (!elementToFocus) return;
    super.closeMenuDrawer(event, elementToFocus);
    this.header.classList.remove('menu-open');
    window.removeEventListener('resize', this.onResize);
  }

  onResize = () => {
    this.header &&
      document.documentElement.style.setProperty(
        '--header-bottom-position',
        `${parseInt(this.header.getBoundingClientRect().bottom - this.borderOffset)}px`
      );
    document.documentElement.style.setProperty('--viewport-height', `${window.innerHeight}px`);
  };
}

customElements.define('header-drawer', HeaderDrawer);

class DetailsDisclosure extends HTMLElement {
  constructor() {
    super();
    this.mainDetailsToggle = this.querySelector('details');
    this.content = this.mainDetailsToggle.querySelector('summary').nextElementSibling;

    this.mainDetailsToggle.addEventListener('focusout', this.onFocusOut.bind(this));
    this.mainDetailsToggle.addEventListener('toggle', this.onToggle.bind(this));
  }

  onFocusOut() {
    setTimeout(() => {
      if (!this.contains(document.activeElement)) this.close();
    });
  }

  onToggle() {
    if (!this.animations) this.animations = this.content.getAnimations();

    if (this.mainDetailsToggle.hasAttribute('open')) {
      this.animations.forEach((animation) => animation.play());
    } else {
      this.animations.forEach((animation) => animation.cancel());
    }
  }

  close() {
    this.mainDetailsToggle.removeAttribute('open');
    this.mainDetailsToggle.querySelector('summary').setAttribute('aria-expanded', false);
  }
}

customElements.define('details-disclosure', DetailsDisclosure);

class HeaderComponent extends HTMLElement {
  constructor() {
    super();
    this.scrollThreshold = this.getAttribute('data-scroll-threshold') || 80;
  }

  connectedCallback() {
    this.setupScrollObserver();
    this.setupNavAccessibility();
  }

  disconnectedCallback() {
    this._scrollCleanup?.();
    this._navA11yCleanup?.();
  }

  // Scroll observer to update the header scrolled state
  setupScrollObserver() {
    const update = () => {
      const y = window.scrollY ?? document.documentElement.scrollTop;
      if (y <= this.scrollThreshold) {
        this.removeAttribute('data-scrolled');
      } else {
        this.setAttribute('data-scrolled', 'true');
      }
    };

    update();
    window.addEventListener('scroll', update, { passive: true });
    window.addEventListener('resize', update);

    this._scrollCleanup = () => {
      window.removeEventListener('scroll', update);
      window.removeEventListener('resize', update);
      this._scrollCleanup = undefined;
    };
  }

  // Accessible header navigation
  setupNavAccessibility() {
    const nav = this.querySelector( '#site-navigation' );
    if ( ! nav ) return;

    const triggers = Array.from(
      nav.querySelectorAll( 'button.nav-item__link[aria-haspopup="true"][aria-controls]' )
    );
    if ( ! triggers.length ) return;

    const triggerToPanel = new Map();
    triggers.forEach( ( btn ) => {
      const panelId = btn.getAttribute( 'aria-controls' );
      if ( ! panelId ) return;
      const panel = this.querySelector( '#' + panelId );
      if ( panel ) triggerToPanel.set( btn, panel );
    } );

    if ( ! triggerToPanel.size ) return;

    const focusableSelector = [
      'a[href]',
      'button:not([disabled])',
      'input:not([disabled])',
      'select:not([disabled])',
      'textarea:not([disabled])',
      '[tabindex]:not([tabindex="-1"])',
    ].join( ',' );

    const getFirstFocusable = ( panel ) => panel?.querySelector( focusableSelector ) ?? null;

    const closeAll = () => {
      triggers.forEach( ( btn ) => {
        btn.setAttribute( 'aria-expanded', 'false' );
        const panel = triggerToPanel.get( btn );
        if ( panel ) panel.setAttribute( 'aria-hidden', 'true' );
      } );
    };

    const openFor = ( btn, { focusPanel = true } = {} ) => {
      closeAll();

      btn.setAttribute( 'aria-expanded', 'true' );
      const panel = triggerToPanel.get( btn );
      if ( panel ) panel.setAttribute( 'aria-hidden', 'false' );

      if ( focusPanel ) {
        const firstFocusable = panel ? getFirstFocusable( panel ) : null;
        if ( firstFocusable && typeof firstFocusable.focus === 'function' ) {
          firstFocusable.focus( { preventScroll: true } );
        }
      }
    };

    const toggle = ( btn ) => {
      const expanded = btn.getAttribute( 'aria-expanded' ) === 'true';
      if ( expanded ) {
        btn.setAttribute( 'aria-expanded', 'false' );
        const panel = triggerToPanel.get( btn );
        if ( panel ) panel.setAttribute( 'aria-hidden', 'true' );
        btn.focus( { preventScroll: true } );
        return;
      }
      openFor( btn );
    };

    // Ensure panels start hidden for assistive tech.
    triggerToPanel.forEach( ( panel ) => {
      if ( panel && ! panel.hasAttribute( 'aria-hidden' ) ) {
        panel.setAttribute( 'aria-hidden', 'true' );
      }
    } );

    const onTriggerClick = ( e ) => {
      e.preventDefault();
      toggle( e.currentTarget );
    };

    let closeTimer = undefined;

    const clearCloseTimer = () => {
      if ( closeTimer ) window.clearTimeout( closeTimer );
      closeTimer = undefined;
    };

    const onTriggerPointerEnter = ( e ) => {
      // Avoid opening on touch/pens; only enable true hover with a mouse.
      if ( e.pointerType && e.pointerType !== 'mouse' ) return;
      // Don't steal focus on hover; just update state.
      clearCloseTimer();
      openFor( e.currentTarget, { focusPanel: false } );
    };

    const onTriggerKeyDown = ( e ) => {
      if ( e.key !== 'Escape' ) return;
      e.preventDefault();
      closeAll();
      e.currentTarget.focus( { preventScroll: true } );
    };

    const onMaybeCloseOnPointerLeave = ( e ) => {
      if ( e.pointerType && e.pointerType !== 'mouse' ) return;

      const openBtn = triggers.find( ( btn ) => btn.getAttribute( 'aria-expanded' ) === 'true' );
      if ( ! openBtn ) return;

      const panel = triggerToPanel.get( openBtn );
      const activeEl = this.ownerDocument?.activeElement ?? document.activeElement;
      if ( panel && activeEl && panel.contains( activeEl ) ) return;
      if ( openBtn.contains( activeEl ) ) return;

      const relatedTarget = e.relatedTarget;
      if ( relatedTarget ) {
        if ( openBtn.contains( relatedTarget ) ) return;
        if ( panel && panel.contains( relatedTarget ) ) return;
      }

      // Delay the close slightly to prevent menus from closing too early.
      clearCloseTimer();
      closeTimer = window.setTimeout( () => {
        const openBtnNow = triggers.find( ( btn ) => btn.getAttribute( 'aria-expanded' ) === 'true' );
        if ( ! openBtnNow ) return;
        const panelNow = triggerToPanel.get( openBtnNow );

        const activeElNow = this.ownerDocument?.activeElement ?? document.activeElement;
        if ( panelNow && activeElNow && panelNow.contains( activeElNow ) ) return;
        if ( activeElNow && openBtnNow.contains( activeElNow ) ) return;

        closeAll();
      }, 300 );
    };

    const onDocumentMouseDown = ( e ) => {
      if ( this.contains( e.target ) ) return;
      closeAll();
    };

    // If focus moves outside the opened panel, close it.
    const onNavFocusIn = ( e ) => {
      const openBtn = triggers.find( ( btn ) => btn.getAttribute( 'aria-expanded' ) === 'true' );
      if ( ! openBtn ) return;

      const panel = triggerToPanel.get( openBtn );
      const target = e.target;
      if ( panel && panel.contains( target ) ) return;
      if ( openBtn.contains( target ) ) return;

      closeAll();
    };

    const ac = new AbortController();
    this._navA11yCleanup?.();

    triggers.forEach( ( btn ) => {
      btn.addEventListener( 'click', onTriggerClick, { signal: ac.signal } );
      btn.addEventListener( 'pointerenter', onTriggerPointerEnter, { signal: ac.signal } );
      btn.addEventListener( 'pointerleave', onMaybeCloseOnPointerLeave, { signal: ac.signal } );
      btn.addEventListener( 'keydown', onTriggerKeyDown, { signal: ac.signal } );
      btn.addEventListener( 'focusin', () => openFor( btn, { focusPanel: false } ), { signal: ac.signal } );
    } );

    // Also close when leaving an open panel (but don't interrupt keyboard focus).
    triggerToPanel.forEach( ( panel ) => {
      panel.addEventListener( 'pointerleave', onMaybeCloseOnPointerLeave, { signal: ac.signal } );
      panel.addEventListener( 'pointerenter', clearCloseTimer, { signal: ac.signal } );
    } );

    nav.addEventListener( 'focusin', onNavFocusIn, { signal: ac.signal } );
    document.addEventListener( 'mousedown', onDocumentMouseDown, { signal: ac.signal, capture: true } );

    this._navA11yCleanup = () => ac.abort();
  }
}

customElements.define('header-component', HeaderComponent);

// Interactive Foil

class InteractiveFoil extends HTMLElement {
  constructor() {
    super();
    this._rafId = 0;
    this._currentX = 100;
    this._currentY = 0;
    this._targetX = 100;
    this._targetY = 0;

    this._tick = this._tick.bind(this);

    this._onWindowPointerMove = (event) => {
      this._onMove(event);
    };
  }

  connectedCallback() {
    this._readSmoothing();
    window.addEventListener('pointermove', this._onWindowPointerMove, { passive: true });
  }

  disconnectedCallback() {
    this._cancelTick();
    window.removeEventListener('pointermove', this._onWindowPointerMove);
  }

  _readSmoothing() {
    const raw = parseFloat(this.getAttribute('data-foil-smooth'));
    const n = Number.isFinite(raw) ? raw : 0.1;
    this._smooth = Math.min(1, Math.max(0.04, n));
  }

  _prefersReducedMotion() {
    return window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  }

  _hasFinePointer() {
    return window.matchMedia('(pointer: fine)').matches;
  }

  _isInViewport() {
    const rect = this.getBoundingClientRect();
    if (rect.width <= 0 || rect.height <= 0) return false;
    return rect.bottom > 0 && rect.right > 0 && rect.top < window.innerHeight && rect.left < window.innerWidth;
  }

  _syncTargetFromEvent(event) {
    const rect = this.getBoundingClientRect();
    if (rect.width <= 0 || rect.height <= 0) return false;

    const x = ((event.clientX - rect.left) / rect.width) * 100;
    const y = ((event.clientY - rect.top) / rect.height) * 100;
    this._targetX = Math.min(100, Math.max(0, x));
    this._targetY = Math.min(100, Math.max(0, y));
    return true;
  }

  _applyOrigin() {
    this.style.setProperty('--foil-light-origin', `${this._currentX}% ${this._currentY}%`);
  }

  _scheduleTick() {
    if (this._rafId) return;
    this._rafId = requestAnimationFrame(this._tick);
  }

  _cancelTick() {
    if (this._rafId) {
      cancelAnimationFrame(this._rafId);
      this._rafId = 0;
    }
  }

  _tick() {
    this._rafId = 0;

    const dx = this._targetX - this._currentX;
    const dy = this._targetY - this._currentY;
    const dist = Math.hypot(dx, dy);

    if (dist > 0.001) {
      this._currentX += dx * this._smooth;
      this._currentY += dy * this._smooth;
    } else {
      this._currentX = this._targetX;
      this._currentY = this._targetY;
    }

    this._applyOrigin();

    const nextDist = Math.hypot(this._targetX - this._currentX, this._targetY - this._currentY);

    if (nextDist > 0.02) {
      this._scheduleTick();
    }
  }

  _onMove(event) {
    if (!this._hasFinePointer()) return;
    if (!this._isInViewport()) return;
    if (!this._syncTargetFromEvent(event)) return;

    if (this._prefersReducedMotion()) {
      this._currentX = this._targetX;
      this._currentY = this._targetY;
      this._applyOrigin();
      return;
    }

    this._scheduleTick();
  }
}

customElements.define('interactive-foil', InteractiveFoil);

// Accordion Group
class AccordionGroup extends HTMLElement {
  constructor() {
    super();
    this.buttons = this.querySelectorAll('button[aria-controls]');
    this.collapsible = this.getAttribute('data-collapsible') === 'true';
  }

  connectedCallback() {
    this.buttons.forEach((button) => {
      button.addEventListener('click', this.toggleAccordion.bind(this));
    });
  }

  toggleAccordion(event) {
    const button = event.currentTarget;
    const expanded = button.getAttribute('aria-expanded') === 'true';
    if (expanded) {
      this.closeAccordion(button);
    } else {
      this.openAccordion(button);
    }
  }

  getPanelForButton(button) {
    const id = button.getAttribute('aria-controls');
    return id ? document.getElementById(id) : null;
  }

  closeAccordion(button) {
    button.setAttribute('aria-expanded', 'false');
  }

  openAccordion(button) {
    if (this.collapsible) {
      this.buttons.forEach((otherButton) => {
        if (otherButton === button) return;
        this.closeAccordion(otherButton);
      });
    }
    button.setAttribute('aria-expanded', 'true');
  }
}

customElements.define('accordion-group', AccordionGroup);

// MicroModal

MicroModal.init({
  openTrigger: 'data-open-modal',
  closeTrigger: 'data-close-modal',
  disableFocus: true,
  awaitCloseAnimation: true,
  onShow: (modal) => {
    document.body.classList.add('overflow-hidden');
  },
  onClose: (modal) => {
    document.body.classList.remove('overflow-hidden');
  }
});
